import { render, staticRenderFns } from "./plan-details-mobile-header.vue?vue&type=template&id=24afcc4f"
import script from "./plan-details-mobile-header.js?vue&type=script&lang=js&external"
export * from "./plan-details-mobile-header.js?vue&type=script&lang=js&external"
import style0 from "./plan-details-mobile-header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports